module.exports = __webpack_public_path__ + "img/专家讲座@2x.9e91f319.png";